import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_PURCHASE_ORDER: createSagaAction('GET_PURCHASE_ORDER'),
  GET_RELATED_LEAD_ESTIMATES: createSagaAction('GET_RELATED_LEAD_ESTIMATES'),
  GET_ESTIMATE: createSagaAction('GET_ESTIMATE')
}

// Action Creators
export const actions = {
  getPurchaseOrder: ({ purchaseOrderId }) => ({
    type: constants.GET_PURCHASE_ORDER.ACTION,
    purchaseOrderId
  }),

  getRelatedLeadEstimates: ({ jobId }) => ({
    type: constants.GET_RELATED_LEAD_ESTIMATES.ACTION,
    jobId
  }),

  getEstimate: ({ estimateId }) => ({
    type: constants.GET_ESTIMATE.ACTION,
    estimateId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_PURCHASE_ORDER.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_PURCHASE_ORDER.SUCCESS:
      return {
        ...state,
        purchaseOrder: action.payload,
        loading: false
      }
    case constants.GET_RELATED_LEAD_ESTIMATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_RELATED_LEAD_ESTIMATES.SUCCESS:
      return {
        ...state,
        loading: false,
        estimates: action.payload
      }
    case constants.GET_ESTIMATE.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ESTIMATE.SUCCESS:
      return {
        ...state,
        loading: false,
        estimate: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/purchaseOrderActions.js